export const UPDATE_FORM_KYC_FILL = 'UPDATE_FORM_KYC_FILL';
export const updateFormKycFill = q => ({
  type: UPDATE_FORM_KYC_FILL,
  payload: q
});
